import { useMutation, useQueryClient } from '@tanstack/react-query';
import { packageServices } from '../services/package.service';
import toast from 'react-hot-toast';

export const useDeletePackage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: packageServices.deletePackage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['packages'] });
      toast.success('Package deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete package');
    },
  });
};
